import React, { useEffect } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";

const MembershipCouponModal = ({
  open,
  handleClose,
  selectedMembership,
  displayRazorpay,
  btnLoading = false,
  setbtnLoading,
  appliedCoupon,
  setAppliedCoupon,
}) => {
  const { userToken, isLoggedIn } = PagesIndex.useSelector(
    (state) => state.UserReducer
  );
  const [couponCode, setCouponCode] = React.useState("");
  const [couponError, setCouponError] = React.useState("");
  const [finalAmount, setFinalAmount] = React.useState(0);
  const [discount, setDiscount] = React.useState(0);
  const price = selectedMembership?.isDiscounted
    ? selectedMembership.discountedPrice
    : selectedMembership?.price || 0;

  // console.log({ selectedMembership });

  // console.log(finalAmount, "finalAmount", appliedCoupon);
  const handleApplyCoupon = async (code) => {
    try {
      const response = await PagesIndex.apiPostHandler(
        PagesIndex.Api.VERIFY_MEMBERSHIP_COUPON,
        { couponCode: couponCode, subscriptionId: selectedMembership?._id },
        userToken
      );
      console.log({ response });
      if (response?.status === 200) {
        setAppliedCoupon(couponCode);
        setFinalAmount(response?.data?.finalAmount);
        setDiscount(response?.data?.totalDiscount);

        PagesIndex.toast.success(response?.message);
        setCouponError("");
      } else {
        setCouponError(response.message || "Invalid coupon code");
      }
    } catch (error) {
      console.error("Error verifying coupon:", error);
      setCouponError("Something went wrong. Please try again.");
    }
  };

  const handleModalClse = () => {
    setCouponCode("");
    setCouponError("");
    setAppliedCoupon(null);
    setDiscount(0);
    handleClose();
    setbtnLoading(false);
    setFinalAmount(price);
  };
  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode("");
    setCouponError("");
    setDiscount(0);
    setFinalAmount(price);
    setbtnLoading(false);
    PagesIndex.toast.success("Coupon removed successfully");
  };

  useEffect(() => {
    if (selectedMembership) {
      setFinalAmount(
        selectedMembership.isDiscounted
          ? selectedMembership.discountedPrice
          : selectedMembership.price || 0
      );
    }
  }, [selectedMembership]);
  return (
    <Index.Modal open={open} onClose={handleModalClse}>
      <Index.Box
        className="membership-coupon-modal"
        sx={{
          width: 900,
          maxHeight: "90vh",
          // bgcolor: "black",
          borderRadius: 2,
          p: 3,
          mx: "auto",
          my: "5vh",
          top: "50%",
          transform: "translateY(-50%)",
          position: "relative",
          boxShadow: 24,
          overflowY: "auto",
          bgcolor: "#1e1e1e",
        }}
      >
        <Index.Box
          sx={{ display: "flex", gap: 4, flexDirection: ["column", "row"] }}
        >
          {/* Left Section: Membership Info */}
          <Index.Box sx={{ flex: 1 }}>
            <Index.Typography variant="h6" sx={{ mb: 2, color: "white" }}>
              {selectedMembership?.title
                ? selectedMembership?.title?.charAt(0).toUpperCase() +
                  selectedMembership?.title?.slice(1).toLowerCase()
                : "-"}
            </Index.Typography>

            <Index.Typography variant="body2" sx={{ mb: 2, color: "gray" }}>
              {selectedMembership?.title === "platinum"
                ? "Enjoy exclusive benefits like free tickets and VIP access"
                : selectedMembership?.title === "gold"
                ? "Unlock special discounts and perks for a premium movie experience"
                : "Get started with basic savings and rewards"}
            </Index.Typography>

            <Index.Box sx={{ mb: 3 }}>
              <Index.Typography variant="h6" sx={{ color: "white" }}>
                Rs.
                {selectedMembership?.isDiscounted ? (
                  <>
                    <span
                      style={{ textDecoration: "line-through", marginRight: 5 }}
                    >
                      {selectedMembership?.price}
                    </span>
                    /<span  style={{ marginLeft: 5 }} >{selectedMembership?.discountedPrice}</span>
                  </>
                ) : (
                  selectedMembership?.price
                )}
              </Index.Typography>
            </Index.Box>

            {/* Benefits */}
            <Index.Box
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              {/* F&B Discount */}
              <Index.Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: selectedMembership?.discountOfFAndBUpTo
                    ? "success.main"
                    : "text.disabled",
                }}
              >
                {selectedMembership?.discountOfFAndBUpTo ? (
                  <Index.CheckIcon sx={{ mr: 1 }} />
                ) : (
                  <Index.ClearIcon sx={{ mr: 1 }} />
                )}
                {selectedMembership?.discountOfFAndBUpTo
                  ? `Upto ${selectedMembership?.discountOfFAndBUpTo}% Discount on F&B: Save on
                           delicious snacks and drinks`
                  : "No Discount on F&B"}
              </Index.Typography>

              {/* Ticket Discount */}
              <Index.Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: selectedMembership?.discountOnTicketUpTo
                    ? "success.main"
                    : "text.disabled",
                }}
              >
                {selectedMembership?.discountOnTicketUpTo ? (
                  <Index.CheckIcon sx={{ mr: 1 }} />
                ) : (
                  <Index.ClearIcon sx={{ mr: 1 }} />
                )}
                {selectedMembership?.discountOnTicketUpTo
                  ? `Upto ${selectedMembership?.discountOnTicketUpTo}% Discount on Tickets: Get
                            more movies for your money`
                  : "No Discount on Tickets"}
              </Index.Typography>

              {/* Coins */}
              <Index.Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: selectedMembership?.coins
                    ? "success.main"
                    : "text.disabled",
                }}
              >
                {selectedMembership?.coins ? (
                  <Index.CheckIcon sx={{ mr: 1 }} />
                ) : (
                  <Index.ClearIcon sx={{ mr: 1 }} />
                )}
                {selectedMembership?.coins
                  ? `Upto ${selectedMembership?.coins}% Coins: Earn rewards redeemable for tickets, concessions, and more`
                  : "No Coins to Earn Rewards"}
              </Index.Typography>

              {/* Welcome Gift */}
              <Index.Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color:
                    selectedMembership?.welcomeGift === "Yes"
                      ? "success.main"
                      : "red",
                }}
              >
                {selectedMembership?.welcomeGift === "Yes" ? (
                  <Index.CheckIcon sx={{ mr: 1 }} />
                ) : (
                  <Index.ClearIcon sx={{ mr: 1,color:"red" }} />
                )}
                {selectedMembership?.welcomeGift === "Yes"
                  ? "Welcome Gift: Receive a special surprise when you join."
                  : "No Welcome Gift"}
              </Index.Typography>
            </Index.Box>
          </Index.Box>

          {/* Right Section: Coupon + Summary */}
          <Index.Box
            sx={{
              flex: 1,
              bgcolor: "#1e1e1e",
              borderRadius: 2,
              p: 3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: 350,
            }}
          >
            {/* Coupon Entry */}
            <Index.Box className="add-snacks-body membership-coupon-body">
              <Index.Box className="summary-box-wrapper">
                <Index.Box className="apply-promocode-box">
                  {!appliedCoupon ? (
                    <>
                      <Index.TextField
                        fullWidth
                        id="promoCode"
                        type="text"
                        className="form-control"
                        placeholder="Enter your Promocode"
                        name="coupencode"
                        value={couponCode}
                        onChange={(e) => {
                          const newValue = e.target.value
                            .toUpperCase()
                            .replace(/[^A-Z0-9]/g, "");
                          if (newValue.length <= 12) {
                            setCouponCode(newValue);
                            setCouponError(""); // Clear error on input change
                          }
                        }}
                        // error={!!couponError}
                        // helperText={couponError}
                      />
                      <PagesIndex.Button
                        primary
                        sx={{ mt: 1 }}
                        onClick={() => {
                          if (couponCode === "") {
                            setCouponError("Please enter promocode");
                          } else {
                            handleApplyCoupon(couponCode);
                          }
                        }}
                      >
                        Apply
                      </PagesIndex.Button>
                    </>
                  ) : (
                    <Index.Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Index.Typography sx={{ color: "lightgreen" }}>
                        Coupon Applied: {appliedCoupon}
                      </Index.Typography>
                      <PagesIndex.Button
                        size="small"
                        onClick={handleRemoveCoupon}
                      >
                        Remove
                      </PagesIndex.Button>
                    </Index.Box>
                  )}
                </Index.Box>
                 <Index.FormHelperText error>
                  {couponError && <span>{couponError}</span>}
                </Index.FormHelperText>
              </Index.Box>
            </Index.Box>

            {/* Summary */}
            <Index.Box sx={{ mt: 4, color: "white" }}>
              {appliedCoupon && (
                <>
                  <Index.Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <span>Subtotal</span>
                    <span>₹{price.toFixed(2)}</span>
                  </Index.Box>
                  <Index.Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <span>Discount</span>
                    <span>- ₹{discount || 0}</span>
                  </Index.Box>
                </>
              )}
              <Index.Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                  mt: 2,
                }}
              >
                <span>Total</span>
                <span>₹{finalAmount}</span>
              </Index.Box>

              <Index.Box className="membership-btn-box">
                <PagesIndex.Button
                  secondary
                  className="membership-btn"
                  fullWidth
                  disabled={btnLoading || finalAmount < 0}
                  sx={{ mt: 3 }}
                  onClick={() => {
                    isLoggedIn
                      ? displayRazorpay({
                          couponCode,
                          membershipId: selectedMembership?._id,
                        })
                      : signInOpen();
                  }}
                >
                  {`Proceed${finalAmount > 0 ? " To Pay" : ""}`}
                </PagesIndex.Button>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </Index.Modal>
  );
};

export default MembershipCouponModal;
